export function NoPageMatch() {
  return (
    <div className="flex">
      <h1 className="mt-4 text-3xl font-bold text-gray-900">There's nothing here</h1>
    </div>
  );
}
